/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudMountAuthorization
 */
export interface CloudMountAuthorization {
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    secret: string;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    accessId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    projectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    tenant?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CloudMountAuthorization
     */
    subscription?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CloudMountAuthorization
     */
    expiry?: number | null;
}

export function CloudMountAuthorizationFromJSON(json: any): CloudMountAuthorization {
    return CloudMountAuthorizationFromJSONTyped(json, false);
}

export function CloudMountAuthorizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudMountAuthorization {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'secret': json['secret'],
        'accessId': !exists(json, 'access_id') ? undefined : json['access_id'],
        'projectId': !exists(json, 'project_id') ? undefined : json['project_id'],
        'endpoint': !exists(json, 'endpoint') ? undefined : json['endpoint'],
        'token': !exists(json, 'token') ? undefined : json['token'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'expiry': !exists(json, 'expiry') ? undefined : json['expiry'],
    };
}

export function CloudMountAuthorizationToJSON(value?: CloudMountAuthorization | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'secret': value.secret,
        'access_id': value.accessId,
        'project_id': value.projectId,
        'endpoint': value.endpoint,
        'token': value.token,
        'tenant': value.tenant,
        'subscription': value.subscription,
        'expiry': value.expiry,
    };
}


